import React from 'react';
import { Modal, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

class ModalRules extends React.Component {
  state = { visible: false };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <>
        <Button type="primary" onClick={this.showModal} shape="round" icon={<InfoCircleOutlined />} size="large"> <strong>Pravidla rozvozu</strong></Button>

        <Modal
          title="Pravidla rozvozu"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="Rozumím podmínkám"
        >
          <p>Rozvážíme každý čtvrtek do 18:00. Poslední objednávku na týž den přijímáme ve čtvrtek do 12h.</p>
          <p>Rozvážíme pouze objednávky nad 700 Kč.</p>
          <p>Zdarma rozvážíme po Praze 5,6 a 7. Ostatní objednávky se s vámi pokusíme vyřešit individuálně.</p>
          {/* <p>Kompletní nabídku můžete také zakoupit na <strong>Křižíkově 17 v Karlíně</strong> ve spřáteleném <a href="https://pivo-klub.cz" target="_blank">Pivovarském klubu Benedict.</a></p> */}
          <p>Platba za objednávku v hotovosti po převzetí zboží.</p>
        </Modal>
      </>
    );
  }
}

export default ModalRules;